module.exports = __webpack_public_path__ + "static/img/an_3.ac389af.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/an_3.png
// module id = 834
// module chunks = 1